// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Ke17","productName":"Table_productName__37GOk"};